import { render, staticRenderFns } from "./CourseBuilder.vue?vue&type=template&id=a82184da&scoped=true&"
import script from "./CourseBuilder.vue?vue&type=script&lang=js&"
export * from "./CourseBuilder.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilder.vue?vue&type=style&index=0&id=a82184da&lang=scss&scoped=true&"
import style1 from "./CourseBuilder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82184da",
  null
  
)

export default component.exports